import { ICellRendererParams } from "ag-grid-community";
import { classHOC } from "components/app/ClassWrapper";
import { FC } from "react";
import { Channel } from "types/portfolio";

const AccountTypeRenderer: FC<ICellRendererParams> = ({ data, node }) => {
  const getColor = (value: string) => {
    switch (value) {
      case Channel["ANNUITY-DIRECT"]:
        return "#63b763";
      case Channel.BLIS:
        return "#08758C";
      case Channel["ANNUITY-NON-DIRECT"]:
        return "#ff7d98";
      case Channel["ONLINE-BABY BEAR"]:
      case Channel["ONLINE-MC ONLINE"]:
      case Channel["ONLINE-WEBEX 11"]:
      case Channel["ONLINE-WEBEX CLASSIC"]:
      case Channel["ONLINE-WEBEX TEAMS ONLINE"]:
        return "#AE7AE2";
      default:
        return "#fff";
    }
  };

  if (node.rowPinned) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      <span
        style={{
          width: 14,
          height: 14,
          borderRadius: "50%",
          backgroundColor: getColor(data?.channel),
          minWidth: 14,
          minHeight: 14,
        }}
      />
      <span
        style={{
          textTransform: "uppercase",
          marginLeft: 6,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {data?.channel}
      </span>
    </div>
  );
};

export default classHOC(AccountTypeRenderer);
